import { VideoModalPlayer } from "./VideoModalPlayer"

export default function VideoSection() {
    return (
        <div className="bg-gradient-to-br from-slate-900 via-purple-900 to-slate-900 p-8 mt-[4px]">
            <div className="max-w-4xl mx-auto">
                <h2 className="text-3xl md:text-4xl font-bold mb-10  text-center text-white">
                    TACTOS - {" "}
                    <span className="bg-gradient-to-r from-[#E7603C] via-[#fd3e3d] to-[#fd3e3d] bg-clip-text text-transparent">
                        The Entrepreneur Copilot Platform
                    </span>
                </h2>

                <VideoModalPlayer
                    youtubeId="x3oDlWqj-hs"
                    title="Discover TACTOS"
                    description="Explore how TACTOS empowers entrepreneurs with AI-driven insights, tools, and support to grow smarter and faster."
                    className="w-full h-96"
                />
            </div>
        </div>
    )
}
